import React, {Component} from 'react';
import './FormField.css'
import './Utilities.css'

export default class FormField extends Component {
	constructor(props) {
		super(props);
		this.state = {
      };
   }
   
   render() {
      let labelStyle = {};
      let childrenStyle = {width: '100%'};
      if (!this.props.vertical) {
         if (this.props.labelWidth) {
            labelStyle = { width: this.props.labelWidth + '%', alignSelf:this.props.labelAlign};
            childrenStyle = { width: (100-this.props.labelWidth) + '%'};
         } else {
            labelStyle = { width: '30%'};
            childrenStyle = { width: '70%'};
         }
      }
      return (
         <div className={this.props.vertical ? 'form-field-vertical' : 'form-field-horizontal'} style={this.props.style}>
            <div className="form-field-label" style={labelStyle}>{this.props.label} 
               {this.props.required &&
                  <span className="form-field-required" style={this.props.requiredStyle}>*</span>
               }
            </div>
            <div className="form-field-children" style={childrenStyle}>{this.props.children}</div>
         </div>
      )
   }
}
